module.exports = __webpack_public_path__ + "img/Docker-Swarm.dec1bcf.svg";